import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import React, {memo} from "react";

const styles = () => {
    return {
        box: ({isLoading}) => {
            return {
                display: isLoading ? "block" : "none",
                position: "fixed",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundColor: "#ffffff80",
                zIndex: 1
            };
        },
        progress: {
            position: "absolute",
            margin: "auto",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    };
};

const Loading = ({classes}) => {
    return (
        <Box className={classes.box}>
            <CircularProgress className={classes.progress}/>
        </Box>
    );
};

Loading.propTypes = {
    isLoading: PropTypes.bool
};
export default memo(withStyles(styles)(Loading));
